import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted,ref } from "vue";
import MainHeader from "@/components/main-header.vue";
// import { useRouter } from "vue-router";

import { WebSite_Name } from "@/interface/globalindex";

import { useHead } from '@vueuse/head'

// const router = useRouter()


export default /*@__PURE__*/_defineComponent({
  __name: 'UserAuth',
  setup(__props) {

const SSRData = ref({
  title: '用户登陆 - '+WebSite_Name,
  description: '默认代码,defaultcode.com 是宁波的开发者技术社区，为开发者提供纯粹、高质的技术交流平台，让有意思的人聚在一起。',
  keywords: '默认代码,默认代码社区,宁波技术社区,宁波开发者技术交流社区,程序员中文技术社区'
})

onMounted(async () => {
  console.log("userauth");
});

// 使用组合式 API 设置 head
useHead({
  title: SSRData.value.title,
  meta: [
    { name: 'description', content: SSRData.value.description },
    { name: 'keywords', content: SSRData.value.keywords }
  ]
})
// 生成随机 state 字符串 (安全增强版)
const generateState = () => {
  const randomBytes = new Uint8Array(16)
  crypto.getRandomValues(randomBytes) // 使用 Web Crypto API
  const state = 
    Array.from(randomBytes, byte => byte.toString(16).padStart(2, '0')).join('') + 
    '_github'
  return state
}

//GitHub登录
const openGitHubLogin = ()=>{
const state = generateState(); // 生成随机 state 字符串

// GitHub OAuth 登录 URL
const url = `https://github.com/login/oauth/authorize?client_id=Ov23liAALOrBXgY5llBh&state=${state}&allow_signup=true`;
window.location.href = url;
}




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(MainHeader),
    _createElementVNode("div", {
      style: {"text-align":"center","margin-top":"200px","cursor":"pointer"},
      onClick: openGitHubLogin
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("svg", {
        t: "1721897194462",
        class: "icon",
        viewBox: "0 0 1024 1024",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "p-id": "4218",
        width: "120",
        height: "120"
      }, [
        _createElementVNode("path", {
          d: "M512 42.666667A464.64 464.64 0 0 0 42.666667 502.186667 460.373333 460.373333 0 0 0 363.52 938.666667c23.466667 4.266667 32-9.813333 32-22.186667v-78.08c-130.56 27.733333-158.293333-61.44-158.293333-61.44a122.026667 122.026667 0 0 0-52.053334-67.413333c-42.666667-28.16 3.413333-27.733333 3.413334-27.733334a98.56 98.56 0 0 1 71.68 47.36 101.12 101.12 0 0 0 136.533333 37.973334 99.413333 99.413333 0 0 1 29.866667-61.44c-104.106667-11.52-213.333333-50.773333-213.333334-226.986667a177.066667 177.066667 0 0 1 47.36-124.16 161.28 161.28 0 0 1 4.693334-121.173333s39.68-12.373333 128 46.933333a455.68 455.68 0 0 1 234.666666 0c89.6-59.306667 128-46.933333 128-46.933333a161.28 161.28 0 0 1 4.693334 121.173333A177.066667 177.066667 0 0 1 810.666667 477.866667c0 176.64-110.08 215.466667-213.333334 226.986666a106.666667 106.666667 0 0 1 32 85.333334v125.866666c0 14.933333 8.533333 26.88 32 22.186667A460.8 460.8 0 0 0 981.333333 502.186667 464.64 464.64 0 0 0 512 42.666667",
          fill: "#231F20",
          "p-id": "4219"
        })
      ], -1),
      _createElementVNode("div", { style: {"margin-top":"20px"} }, "请使用GitHub登录", -1)
    ]))
  ]))
}
}

})